import { IUserFull } from '../entities/user';
import { ISchedule } from '../entities/schedule';

export type WorkingLocationPolicy = {
  type: string;
  status: string;
};

export type WorkingLocation = {
  location: string | null;
  policy: WorkingLocationPolicy;
  office_id: string | null;
  schedules: ISchedule[];
};

export type TableOverviewUser = {
  user: IUserFull;
  working_locations: Record<string, WorkingLocation>;
  favorite_team_ids: string[] | [];
};

export type TableOverviewDayResponse = {
  people_in_office: number;
  favorite_people_in_office: number;
};

export type TableOverviewResponse = {
  total_people_in_office: number;
  total_favorite_people_in_office: number;
  days: Record<string, TableOverviewDayResponse>;
  users: TableOverviewUser[];
  cursor: string;
};

export enum PossibleDateSort {
  ASC = 'asc',
  DESC = 'desc'
}

export type TableOverviewParams = {
  office_ids?: string[];
  division_ids?: string[];
  date?: string;
  tz?: string;
  user_tz: string;
  team_id?: string[];
  limit?: number;
  cursor?: string;
  user_id?: string[];

  date_sort_order?: PossibleDateSort;
  date_sort?: string;
  is_single_date?: boolean;
};
